import React, { useEffect, useState } from "react";
import "../../styles/transaction.css";
import InvestersTable from "../../components/Admin/InvestersTable";
import Pagination from "../../components/Pagination";
import { useDispatch, useSelector } from "react-redux";
import "../../styles/SelectDropDown.css";
import Loader from "../../loader/Loader-ui";
import { investorList, investorListExport } from "../../actions/adminAction";
import InvestButton from "../../components/Admin/InvestButton";
import exportIcon from "../../images/icons/export.svg";
import { IoSearch } from "react-icons/io5";
import { FaPlus } from "react-icons/fa6";
import IINStatus from "../../images/icons/IINStatus.svg";
import Instaiinreport from "../../images/icons/InvestmentReport.svg";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Transaction = () => {
  const dispatch = useDispatch(); // Initialize dispatch
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchFunds, setSearchFunds] = useState("");
  const [rmType, setRMType] = useState("");
  const navigate = useNavigate();
  const fetchInvestorList = async () => {
    try {
      setIsLoading(true);
      await dispatch(
        investorList({
          page_num: currentPage,
          per_page: "10",
          search: searchFunds,
          rmId: rmType,
        })
      );
    } catch (error) {
      console.error("Error fetching watchlist:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchInvestorListExport = async () => {
    try {
      setIsLoading(true);
      const payload = {
        search: searchFunds,
        rmId: rmType,
      };
      await dispatch(investorListExport(payload)).then((response) => {
        if (response.status === true) {
          handleButtonClick(response);
        } else {
          toast.error(response?.message);
        }
      });
    } catch (error) {
      console.error("Error fetching watchlist:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchInvestorList();
  }, [currentPage, searchFunds, rmType]);

  const { adminInvestorList = {} } = useSelector((state) => state?.admin);

  const investorSchemeData = adminInvestorList?.data?.investorsList || [];
  const totalPages = adminInvestorList?.data?.pagination?.total_pages || 1;
  const rmUserList = adminInvestorList?.data?.rmsList || [];

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleFundSearchChange = (e) => {
    setSearchFunds(e.target.value);
    setCurrentPage(1); // Reset to first page when search changes
  };

  const handleExportChange = () => {
    fetchInvestorListExport();
  };

  const handleButtonClick = (response) => {
    const fileUrl = response?.data?.report_url;
    if (fileUrl) {
      const anchor = document.createElement("a");
      anchor.href = fileUrl;
      anchor.download = "";
      // anchor.target = "_blank";
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } else {
      console.error("File URL not found in the response");
    }
    toast.success(response?.message);
    // navigate('/reports-list', { state: { apiResponse: response } });
  };

  const handleRMIdChange = (e) => {
    setRMType(e.target.value);
    setCurrentPage(1); // Reset to first page when search changes
  };

  // Function to clear all filters
  const clearFilters = () => {
    setRMType("");
    setSearchFunds("");
    setCurrentPage(1); // Reset to first page when search changes
  };

  return (
    <div className="container-fluid page_background">
      {isLoading && (
        <div className="loader-overlay">
          <Loader />
        </div>
      )}
      <div className="page-inner-content mb-3">
        <div className="page_inner_content_box">
          {/* <h5 className="mb-4 main-heading-title">Investments</h5> */}

          <div className="d-flex justify-content-between mb-3 align-items-center">
            <h5 className="mb-4 main-heading-title investment-heading-title">
              Investors{" "}
            </h5>

            <div className="investor-btn-container">
              <div>
                <InvestButton
                  label={
                    <>
                      <FaPlus className="mr-1" />
                      Add
                    </>
                  }
                  url="/admin/investeradd"
                  color="blue"
                  className="white-space-nowrap investor-btn-p-10"
                />
              </div>

              <div>
                <InvestButton
                  label={
                    <>
                      <img
                        src={Instaiinreport}
                        alt="Insta IIN Report"
                        className="mr-1"
                      />{" "}
                      Insta IIN Report
                    </>
                  }
                  color="blue"
                  className="white-space-nowrap investor-btn-p-10"
                  onClick={() => {
                    navigate("/admin/iinstatusreport", {
                      state: { from: "investors" },
                    });
                  }}
                />
              </div>

              <div>
                <InvestButton
                  label={
                    <>
                      <img src={exportIcon} className="mr-1" />
                      Export
                    </>
                  }
                  color="blue"
                  onClick={handleExportChange}
                  className="white-space-nowrap investor-btn-p-10"
                  state={{ from: "goals" }}
                />
              </div>

              {/* <div>
                <InvestButton
                  label={
                    <>
                      <img src={IINStatus} alt="IIN Status" className="mr-1" />{" "}
                      IIN Status
                    </>
                  }
                  url="/admin/customersiinstatus"
                  color="blue"
                  className="white-space-nowrap investor-btn-p-10"
                  state={{ from: "goals" }}
                />
              </div> */}
            </div>
          </div>

          <div className="search-container">
            <div>
              <div className="row align-items-end">
                <div className="col-md-3 col-sm-6 col-xs-12 mb-3">
                  <div className="position-relative">
                    <IoSearch className="search-icon-custom" />
                    <input
                      type="text"
                      className="search-input-custom"
                      placeholder="Search Name"
                      value={searchFunds}
                      onChange={handleFundSearchChange}
                    />
                  </div>
                </div>

                {/* Relationship Manager Dropdown */}
                <div className="col-md-3 col-sm-6 col-xs-12 mb-3">
                  <div className="dropdown-label-custom">
                    Relationship Manager
                  </div>
                  <select
                    className="form-select custom-select2"
                    value={rmType} // Set selected value
                    onChange={handleRMIdChange} // Handle selection
                    displayEmpty
                  >
                    <option value={""} disabled>
                      Select
                    </option>
                    {rmUserList
                      ?.filter(
                        (rm) => rm?.user?.name && rm.user.name.trim() !== ""
                      )
                      .map((rm, index) => (
                        <option key={index} value={rm.id}>
                          {rm.user.name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-md-3 col-sm-6 col-xs-12 mb-3">
                  <InvestButton
                    label={<>Clear</>}
                    color="blue"
                    className="white-space-nowrap investor-btn-p-10"
                    onClick={clearFilters}
                  />
                </div>
                <div className="col"> </div>
              </div>
            </div>
          </div>

          <div className="transaction_tab">
            <div className="tab-content">
              <div
                className="tab-pane fade show active"
                id="mailBack"
                role="tabpanel"
                aria-labelledby="mailBack-tab"
              >
                <InvestersTable
                  data={investorSchemeData}
                  currentPage={currentPage}
                  // selectedType={selectedType}
                  // selectedStatus={selectedStatus}
                  // onTypeChange={handleTypeChange}
                  // onStatusChange={handleStatusChange}
                />
                <div className="pt-5">
                  <Pagination
                    totalPages={totalPages}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    color="primary"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transaction;
